import React, { useEffect, useRef, useState } from "react";
import styles from "./HalloweenDecor.module.css";
import SeasonalLottie, { GHOST_PATH } from "./SeasonalLottie";

// SCRUM-922: ghost easter egg on the Halloween Sign-in page.

const rand = (min, max) => min + Math.random() * (max - min);

// A small friendly ghost that drifts across the hero (left of the card) every
// so often: random wait, height, direction, size and speed each time. Mounted
// only during a flight, so nothing runs between appearances.
export const FloatingGhost = () => {
  const [flight, setFlight] = useState(null);
  const flights = useRef(0);

  useEffect(() => {
    if (flight) return undefined;
    // First visit right after the page settles; later ones a little apart.
    const wait = flights.current === 0 ? rand(1000, 2500) : rand(5000, 10000);
    flights.current += 1;
    const timer = setTimeout(() => {
      setFlight({
        id: Date.now(),
        top: `${Math.round(rand(8, 46))}%`,
        size: Math.round(rand(70, 110)),
        duration: Math.round(rand(11, 17)),
        reverse: Math.random() < 0.5,
      });
    }, wait);
    return () => clearTimeout(timer);
  }, [flight]);

  if (!flight) return null;

  return (
    <div
      key={flight.id}
      className={`${styles.ghostFlight} ${flight.reverse ? styles.ghostFlightReverse : ""}`}
      style={{
        top: flight.top,
        width: flight.size,
        height: flight.size,
        animationDuration: `${flight.duration}s`,
      }}
      onAnimationEnd={(e) => e.target === e.currentTarget && setFlight(null)}
    >
      <SeasonalLottie path={GHOST_PATH} className={styles.ghostBody} />
    </div>
  );
};
